function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Marker");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Foundation-/-icons-/-location-point",
  transform: "translate(-3.000000, -2.000000)",
  fill: "#06273A"
}, React.createElement("path", {
  d: "M18,4.47999999 C14.6862915,1.16629149 9.3137085,1.16629149 5.99999999,4.47999999 C2.68629149,7.79370849 2.68629149,13.1662915 5.99999999,16.48 L11.27,21.76 C11.4577666,21.9493127 11.7133625,22.0557983 11.98,22.0557983 C12.2466375,22.0557983 12.5022334,21.9493127 12.69,21.76 L18,16.43 C21.2998605,13.1300817 21.2998605,7.7799183 18,4.47999999 Z M16.57,15 L12,19.59 L7.43,15 C4.90891202,12.4766032 4.91015972,8.3874325 7.43278713,5.86557469 C9.95541454,3.34371688 14.0445855,3.34371688 16.5672129,5.86557469 C19.0898403,8.3874325 19.091088,12.4766032 16.57,15 L16.57,15 Z M9,7.41 C7.31919382,9.09598381 7.31919382,11.8240162 9,13.51 C10.2262833,14.7383823 12.0697578,15.1113102 13.6770737,14.4561542 C15.2843896,13.8009983 16.3418684,12.2456166 16.36,10.51 C16.3691047,9.36489735 15.9146391,8.26480195 15.1,7.46 C14.2995151,6.6411508 13.2054787,6.17541431 12.0604014,6.16602844 C10.9153241,6.15664256 9.81380021,6.60438264 9,7.41 Z M13.69,12.09 C12.9084734,12.8834601 11.6746984,13.0129043 10.7455076,12.3989277 C9.81631681,11.7849511 9.45154696,10.5992447 9.87495824,9.56915461 C10.2983695,8.53906448 11.3915602,7.95264254 12.4839361,8.16961666 C13.5763119,8.38659078 14.3624035,9.34628683 14.3600055,10.46 C14.3454521,11.0772701 14.0864919,11.6635273 13.64,12.09 L13.69,12.09 Z"
})));

var SvgMarker = function SvgMarker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "18px",
    height: "21px",
    viewBox: "0 0 18 21",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMarker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/marker.a25daeb5.svg";
export { ForwardRef as ReactComponent };